import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	unassigned: {
		id: 'software-backlog-panel.epic.epic-panel.epic-card-list.epic-card.unassigned',
		defaultMessage: 'Issues without {target}',
		description: 'Message in the filter describing issues without parents.',
	},
	confirmMessage: {
		id: 'software-backlog-panel.epic.epic-panel.epic-card-list.epic-card.confirm-message',
		defaultMessage:
			'{numberOfIssues, plural, one {{issueKey} added to {epicIssueTypeName}} other {# issues added to {epicIssueTypeName}}}',
		description: 'Confirmation message that shows on the epic card',
	},
	unassignedIssueTermRefresh: {
		id: 'software-backlog-panel.epic.epic-panel.epic-card-list.epic-card.unassigned-issue-term-refresh',
		defaultMessage: 'No {target}',
		description: 'Message in the filter describing issues without parents.',
	},
	confirmMessageIssueTermRefresh: {
		id: 'software-backlog-panel.epic.epic-panel.epic-card-list.epic-card.confirm-message-issue-term-refresh',
		defaultMessage:
			'{numberOfIssues, plural, one {{issueKey} added to {epicIssueTypeName}} other {# work items added to {epicIssueTypeName}}}',
		description: 'Confirmation message that shows on the epic card',
	},
});
